// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const Firebase = {
    apiKey: "AIzaSyCGXNhyQ_P33N3I9ESMhPWQ7VoZrVAw3GM",
    authDomain: "openforge-23b90.firebaseapp.com",
    projectId: "openforge-23b90",
    storageBucket: "openforge-23b90.appspot.com",
    messagingSenderId: "459456210647",
    appId: "1:459456210647:web:764658d28d350a0b0b7292",
    measurementId: "G-GH3E02P6EL"
};

// Initialize Firebase
const app = initializeApp(Firebase);
const analytics = getAnalytics(app);

export { app, analytics };
